export default __webpack_public_path__ + "static/media/strike_through_icon_white.42168562.svg";